"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.0506 22.6074-5.6569-5.6568L16.9501 1.3942l5.6568 5.6569L7.0506 22.6074zm0-2.8284L19.7785 7.051l-2.8284-2.8284-1.4147 1.4147 1.4152 1.4152-1.4142 1.4142-1.4152-1.4151-1.4142 1.4141 1.415 1.415-1.4143 1.4141-1.4149-1.4149-1.4141 1.4142 1.4146 1.4147-1.4142 1.4142-1.4147-1.4147-1.4141 1.4141 1.4144 1.4145-1.4142 1.4142-1.4144-1.4144-1.414 1.4139 2.8285 2.8284z"
  })];
};

exports.default = _default;